/* eslint-disable @typescript-eslint/no-explicit-any */
import { FilterFn } from '@tanstack/react-table';

function testFalsey(val: any) {
    return val === undefined || val === null || val === '';
}

/**
 * Filter function that checks if any value in filterValue array matches the row value
 * Handles null/undefined row values by checking if filterValue contains 'None'
 * For non-null values, checks if the row value includes the filter value
 * @param row - The row object containing the value to filter
 * @param columnId - The ID of the column to filter on
 * @param filterValue - Array of values to filter against
 * @returns boolean indicating if the row matches any filter value
 */
const arrIncludesSomeWithNulls: FilterFn<any> = (
    row,
    columnId: string,
    filterValue: unknown[]
) =>
    filterValue.some((val) => {
        const rowValue = row.getValue<unknown[]>(columnId);
        if (rowValue == null) {
            return val === 'Null'; // Capitalized to match the one in Header's includeNullValue.
        }
        return [rowValue]?.includes(val as any);
    });

arrIncludesSomeWithNulls.autoRemove = (val: any) => !val?.length;

/**
 * Filter function that checks if any value in filterValue array matches the row value
 * Simply checks if the row value includes the filter value without special null handling
 * @param row - The row object containing the value to filter
 * @param columnId - The ID of the column to filter on
 * @param filterValue - Array of values to filter against
 * @returns boolean indicating if the row matches any filter value
 */
const theRealArrIncludesSome: FilterFn<any> = (
    row,
    columnId: string,
    filterValue: unknown[]
) =>
    filterValue.some((val) => {
        const rowValue = row.getValue<unknown[]>(columnId);
        return [rowValue]?.includes(val as any);
    });

theRealArrIncludesSome.autoRemove = (val: any) =>
    testFalsey(val) || !val?.length;

export const filterFns = {
    arrIncludesSomeWithNulls,
    theRealArrIncludesSome
};
